import React from "react";

import Link from "../../Link";

import useAnimation from "../../../hooks/useAnimation";
import SecureAnimation from "../../../../static/animations/zipstocks/use-secure-animation.json";
import LowFeesAnimation from "../../../../static/animations/zipstocks/use-low-fees-animation.json";
import RegisteredAnimation from "../../../../static/animations/zipstocks/use-registered-animation.json";

const WhyUseZipmex = ({ content, reasonContents }) => {
  useAnimation({
    container: "#zipstocks-why-use-zipmex-reason__secure",
    animationData: SecureAnimation,
  });
  useAnimation({
    container: "#zipstocks-why-use-zipmex-reason__low-fees",
    animationData: LowFeesAnimation,
  });
  useAnimation({
    container: "#zipstocks-why-use-zipmex-reason__registered",
    animationData: RegisteredAnimation,
  });

  return (
    <div className="zipstocks why-use-zipmex">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col text-center">
            <h2 className="text-center">
              {content.nodes[0].acfPartials.pHeading}
            </h2>

            <div
              className="main-content description"
              dangerouslySetInnerHTML={{
                __html: content.nodes[0].acfPartials.pContent,
              }}
            />

            <Link
              className="button button-secondary"
              to={content.nodes[0].acfPartials.pButtonUrl}
            >
              {content.nodes[0].acfPartials.pButtonText} &#8594;
            </Link>
          </div>
        </div>
        <div className="why-use-zipmex__list row">
          {reasonContents.nodes.map(({ acfPartials: reason }) => (
            <div
              className="col-12 col-md-4 mb-4 mb-md-0"
              data-sal="slide-up"
              data-sal-duration="400"
              data-sal-easing="ease-in-quad"
            >
              <div className="card h-100">
                <div className="card-body">
                  <div
                    className="animation mb-4"
                    id={reason.pElementId}
                    data-sal="fade"
                  />
                  <h3 className="mb-3">{reason.pHeading}</h3>
                  <div dangerouslySetInnerHTML={{ __html: reason.pContent }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyUseZipmex;
